import * as React from "react";
import { Column } from "primereact/column";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { getDeviceByImeiEnd } from "../../api/devices"
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { getDateTime, DropdownFilterElement, filterDateTime } from "../../components/TableUtils";
import { useAuth0 } from "../../auth/react-auth0-wrapper"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from 'classnames';
import Can from "../../auth/Can";
import roles from "../../auth/roles";

export default function DeviceList() {

    let dtable;
    const { eventBus, domains } = useAuth0();

    const [totalRecords, setTotalRecords] = React.useState(0);
    const [sortField, setSortField] = React.useState("lastUpdate");
    const [sortOrder, setSortOrder] = React.useState(-1);

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const { gisApi } = useAuth0();
    const [gisDeviceInfo, setGisDeviceInfo] = React.useState();

    React.useEffect(() => {
        initData();
    }, []);

    async function initData() {
        await gisApi.login();
        const gisDevice = await gisApi.getDevice();
        if (gisDevice) {
            setGisDeviceInfo(gisDevice);
            setTotalRecords(gisDevice.length);
        }
    }

    const onWakeUp = async id => {
        try {
            const device = await getDeviceByImeiEnd(id);
            gisApi.smsCommand(device.number, "p l getrecord");
            eventBus.dispatchEvent(
                new CustomEvent("growl", {
                    detail: {
                        message: {
                            type: "info",
                            clear: true,
                            summary: "OPERAZIONE ESEGUITA",
                            content: "Comando SVEGLIA inviato."
                        }
                    }
                })
            );
        } finally {
            toggle();
            return;
        }
    };

    const onSendCommandAPI = async id => {
        try {
            const command = prompt("Digitare il comando CUSTOM da inviare via API al dispositivo:");
            if (!command) return;

            await gisApi.sendComand(id, command, command, false);                
            eventBus.dispatchEvent(
                new CustomEvent("growl", {
                    detail: {
                        message: {
                            type: "info",
                            clear: true,
                            summary: "OPERAZIONE ESEGUITA",
                            content: "Comando CUSTOM inviato via API."
                        }
                    }
                })
            );
        } finally {
            return;
        }
    };

    const onSendCommandSMS = async id => {
        try {
            const command = prompt("Digitare il comando CUSTOM da inviare via SMS al dispositivo:");
            if (!command) return;

            const device = await getDeviceByImeiEnd(id);
            gisApi.smsCommand(device.number, command);
            
            eventBus.dispatchEvent(
                new CustomEvent("growl", {
                    detail: {
                        message: {
                            type: "info",
                            clear: true,
                            summary: "OPERAZIONE ESEGUITA",
                            content: "Comando CUSTOM inviato via SMS."
                        }
                    }
                })
            );
        } finally {
            return;
        }
    };

    const onDeleteDevice = async device => {
        try {
            const proceed = confirm(`Confermi la cancellazione dal GIS del dispositivo con ID/IMEI: ${device.uniqueId}?`);
            if (!proceed) {
                return;
            }
            const deleted = await gisApi.deleteDevice(device.id);
            //console.log(`device ${device.id} deletion result: ${deleted}`)
            eventBus.dispatchEvent(
                new CustomEvent("growl", {
                    detail: {
                        message: {
                            type: deleted ? "success" : "error",
                            clear: true,
                            summary: "OPERAZIONE ESEGUITA",
                            content: deleted ? "Comando di cancellazione eseguito correttamente." : "Errore di cancellazione del dispositivo."
                        }
                    }
                })
            );
        } catch {
            //console.log('Failure deleting device from GIS.')
        } finally {
            initData();
            return;
        }
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Sveglia Dispositivo
      </ModalHeader>
            <ModalBody>
                <p>Confermi di voler svegliare via SMS il Dispositivo con ID/IMEI: {openModal.uniqueId}?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="warning" className="ml-auto" onClick={() => onWakeUp(openModal.uniqueId)}>Sveglia</Button>
            </ModalFooter>
        </Modal>
    );

    return (
        <PageLayout title="Controllo Dispositivi su GIS">
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        value={gisDeviceInfo}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={50}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        onSort={(e) => { setSortField(e.sortField); setSortOrder(e.sortOrder); console.log(sortOrder) }}
                        totalRecords={totalRecords}
                        paginatorPosition="both"
                        emptyMessage={() => (<div className="text-center">Nessun dispositivo in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Dispositivi su un totale di {totalRecords} nel GIS"
                    >
                        <Column
                            field="uniqueId"
                            style={{ wordWrap: "break-word" }}
                            header="ID/IMEI"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="phone"
                            style={{ wordWrap: "break-word" }}
                            header="Telefono"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="name"
                            style={{ wordWrap: "break-word" }}
                            header="Denominazione GIS"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="model"
                            style={{ wordWrap: "break-word" }}
                            header="Modello"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="lastUpdate"
                            style={{ wordWrap: "break-word" }}
                            header="Ultima rilevazione nel GIS"
                            sortable
                            filter
                            body={getDateTime}
                            filterMatchMode="custom"
                            filterFunction={filterDateTime}
                        />
                        <Column
                            field="positionId"
                            style={{ wordWrap: "break-word" }}
                            header="Ultima posizione"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="status"
                            header="Stato"
                            sortable
                            filter
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            filterElement={
                                <DropdownFilterElement
                                    field="status"
                                    options={domains.devicesStatus}
                                    onChange={(opt) => {
                                        dtable.filter(opt.value, opt.field, opt.type);
                                    }}
                                />
                            }
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                                );
                            }}
                        />
                        <Column
                            field="actions"
                            body={(rowData, column) => {

                                return (
                                    <div className="action-container">
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() => (
                                                <React.Fragment>
                                                    <Button
                                                        color="default"
                                                        title="Invia un comando CUSTOM al dispositivo via API"
                                                        onClick={() => onSendCommandAPI(rowData.id)}
                                                        className="btn-sm p-button-icon-only"
                                                    >
                                                        <FontAwesomeIcon icon="comment" />
                                                    </Button>
                                                    <Button
                                                        color="info"
                                                        title="Invia un comando CUSTOM al dispositivo via SMS"
                                                        onClick={() => onSendCommandSMS(rowData.uniqueId)}
                                                        className="btn-sm p-button-icon-only"
                                                    >
                                                        <FontAwesomeIcon icon="sms" />
                                                    </Button>
                                                    {/* <Button
                                                        color="danger"
                                                        title="Elimina il dispositivo dal GIS"
                                                        onClick={() => onDeleteDevice(rowData)}
                                                        className="btn-sm p-button-icon-only"
                                                    >
                                                        <FontAwesomeIcon icon="trash-alt" />
                                                    </Button> */}
                                                    {rowData.status === "offline" && (
                                                        <Button
                                                            color="warning"
                                                            title="Sveglia il dispositivo via SMS"
                                                            onClick={() => setOpenModal(rowData)}
                                                            className="btn-sm p-button-icon-only rm-2"
                                                        >
                                                            <FontAwesomeIcon icon="stopwatch" />
                                                        </Button>
                                                    )}
                                                </React.Fragment>
                                            )}
                                            no={() => null}
                                        />
                                    </div>
                                )
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout >
    );
}
